export default __webpack_public_path__ + "static/media/access-fee_en.2a55edec.png";